import React from 'react';

import styled, { css } from 'styled-components';

import { Skeleton } from 'fpay-ui';

const Layout = styled.div(
  ({ theme }) => css`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 6px;
  margin-bottom: 16px;
  width: 100%;
    &:last-child {
      margin-bottom: 0px;
    }
    ${theme.breakpoint('md')} {
    margin-bottom: 0px;
    margin-right: 16px;
    &:last-child {
      margin-right: 0px;
    }
  }
  ${theme.breakpoint('ll')} {
    max-width: 295px;
  }
  ${theme.breakpoint('xl')} {
    max-width: 283px;
    margin-right: 18px;
  }
`);

const Container = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 22px;
  padding-right: 22px;
  z-index: 1;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Mount = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 18px;
`;

const DetailText = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 23px;
`;

const SkeletonTitle = styled(Skeleton)(
  ({ theme }) => css`
  max-width: 124px;
  height: 22px;
  ${theme.breakpoint('md')} {
    width: 105px;
  }
  ${theme.breakpoint('ll')} {
    width: 124px;
  }
`);

const SkeletonMount = styled(Skeleton)`
  max-width: 125px;
  height: 25px;
`;

const SkeletonDetailText = styled(Skeleton)`
  max-width: 75px;
  height: 16px;
`;

const HelpLink = styled.div`
  background: #f0f0f0;
  border-radius: 0 0 6px 6px;
  height: 40px;
  margin-top: -13px;
  padding: 22px 16px 7px;
`;

const SkeletonAmountCard = ({ helpLink }) => (
  <Layout>
    <Container>
      <Header>
        <SkeletonTitle />
        <Skeleton type="none" width="22px" height="22px" borderRadius="50%" />
      </Header>
      <Mount>
        <SkeletonMount />
      </Mount>
      <DetailText>
        <SkeletonDetailText />
      </DetailText>
    </Container>
    {helpLink ? <HelpLink /> : ''}
  </Layout>
);

export default SkeletonAmountCard;
